module.exports = __webpack_public_path__ + "static/launch-d63f32543e2a3271c5f9269de99e2aa3.jpg";